/* eslint-disable no-new-func */
import HybridConfig from "lib/HybridConfig";
import { auditable } from "audit";
import { buildInterpolator } from "data/selectors/entityFields";

function _or_munge_info(statics) {
    if (statics == null) return null;
    statics.KEY = statics.INFO.key;
    statics.TABLE = statics.INFO.logicalKey;
    statics.LABEL = statics.INFO.name;
    statics.PLURAL_LABEL = statics.INFO.pluralName;
    statics.ORDERING_COMPONENTS = statics.INFO.orderingComponents;
    statics.KEYS = statics.INFO.keys;
    statics.IMPLEMENTATION = (statics.KEY || "").split("/")[0];
    statics.FIELD_ORDER = {};
    statics.FIELD_INFO = {};
    statics.LOGICAL_KEY_MAP = {};
    const iterable = statics.INFO.fields || [];
    for (let i = 0; i < iterable.length; i++) {
        const f = iterable[i];
        f.order = i;
        statics.FIELD_ORDER[f.key] = i;
        statics.FIELD_INFO[f.key] = f;
        if (f.key !== f.logicalKey) {
            statics.LOGICAL_KEY_MAP[f.key] = f.logicalKey;
        }
        if (f.hasOwnProperty("conditions")) {
            for (const c of f.conditions) {
                c.expression = Function("instance", "return " + c.expression + ";");
                if (HybridConfig.auditScriptlets()) {
                    c.expression = auditable("choicecondition", c.expression);
                }
            }
        }
        const {
            scripts
        } = f;
        if (Object.keys(scripts).length === 0) {
            continue;
        }
        const object = {
            ENABLEMENT: [
                "enable"
            ],
            ASSIGNMENT: [
                "recalc"
            ],
            VALIDATION: [
                "validation",
                "minLength",
                "maxLength",
                "min",
                "max",
                "usualMin",
                "usualMax",
            ],
            CANDIDATE_FILTER: [
                "filter",
                "partialFilter"
            ],
        };
        for (const depType in object) {
            for (const sn of object[depType]) {
                if (scripts.hasOwnProperty(sn) && (scripts[sn] != null)) {
                    if (sn === "filter") {
                        scripts[sn] = Function(
                            "instance",
                            "it"/*com.armus.script.transform.MapperBinder.ITEM_NAME*/,
                            "return " + scripts[sn] + ";"
                        );
                    } else if (sn === "partialFilter") {
                        if(HybridConfig.get("ui.usePartialCandidateFilter", true) == false) {
                            // allows testing of fallback candidateFilter search.
                            scripts[sn] = null;
                            continue;
                        }
                        scripts[sn] = buildInterpolator(scripts[sn]);
                    } else if ((f.type === "DecimalField") && (["recalc", "min", "max", "usualMin", "usualMax"].includes(sn))) {
                        // per HO-2159, taken from the old `vfac` macro
                        scripts[sn] = ((raw => (function(instance) {
                            let v = raw(instance);
                            if (v != null) {
                                v = v.toString();
                            }
                            return v;
                        })))(Function("instance", scripts[sn]));
                    } else {
                        scripts[sn] = Function("instance", scripts[sn]);
                    }
                    if (HybridConfig.auditScriptlets()) {
                        scripts[sn] = auditable(sn, scripts[sn]);
                    }
                }
            }
        }
    }
    if (statics.ASSOCIATIONS != null) {
        for (const k in statics.ASSOCIATIONS) {
            const v = statics.ASSOCIATIONS[k];
            statics.ASSOCIATIONS[k] = v.split(",");
        }
    }
    return statics;
}

export default _or_munge_info;



// WEBPACK FOOTER //
// ./app/jsmodel/_or_munge_info.js